<template>
    <!-- <div class="modal-backdrop">
        <div class="card col-lg-4 col-md-8 mt-md-4 col-11 p-0">
            <div class="modal-content postmodalcontent" >
                <div class="modal-header">
                    <h4 class="modal-title titlemodal proximanova-semibold fontsize16 black80">Contact Us</h4>
                </div>
            </div>
        </div>
    </div> -->
    <div class="modal-backdrop">
        <div class="card col-lg-6 col-md-8 mt-md-4 col-11 p-0">
            <div class="modal-content postmodalcontent" >
                <div class="modal-header">
                    <h4 class="modal-title titlemodal proximanova-semibold fontsize16 black80">Contact Us</h4>                
                    <div class="closebtnmouseover" >
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                </div>
                <div class="modal-body bodymodal11">
                    <div class="pb-4 pl-4 pr-4 pt-0">
                        <div class="row ">
                            <div class="col-lg-6 col-md-6 text-left">
                                <label for="firstName" class="labelNames">Name</label>
                                <input id="firstName" type="text" placeholder="First Name" autocomplete="off" v-model="userName">
                            </div>
                            <div class="col-lg-6 col-md-6 text-left">
                                <label for="email" class="labelNames">Email</label>
                                <input id="email" type="email" placeholder="test@gmail.com" @keyup="emailValidation" autocomplete="off" v-model="userEmail">
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-lg-6 col-md-6 text-left">
                                    <label for="phoneNumber" class="labelNames">Phone Number</label>
                                    <div class="d-flex">
                                        <select id="countrycode" class="countrycode" v-model="countrycode" >
                                            <!-- <option v-for="(cc,index) in countryCodes" data-thumbnail="../../assets/flagUSA.png" class="option" :value="cc.countryCode" :key="index"> <img src="../../assets/flagUSA.png" alt=""> {{cc.country}}({{cc.countryCode}})</option> -->
                                        </select>
                                        <input id="phoneNumber" maxlength="10" @keyup="checkMobileNumber" placeholder="9********9" autocomplete="off" v-model="phoneNumber">
                                    </div>
                            </div>
                            <div class="col-lg-6 col-md-6 text-left">
                                <label for="company" class="labelNames">Company</label>
                                <input id="company" type="text" placeholder="Company"  autocomplete="off" v-model="company">
                            </div>

                        </div>
                        <div class="row mt-3">
                            <div class="col-lg-6 col-md-6 text-left">
                                <label for="Location" class="labelNames">Location</label>
                                <input id="Location" type="text" placeholder="Location" autocomplete="off" v-model="locationName">
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-12 text-left">
                                <label for="description" class="labelNames">Description</label>
                                <input id="description" type="text" placeholder="Description" v-model="Description">
                            </div>
                        </div>
                            
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="mr-3 btn button-cancel1" @click="close">
                        <span class="">Cancel</span>
                    </button>
                    <button class="mr-3 btn backgroundcolorblack white">
                        <span class="button-create-font">Submit</span>
                    </button>
                    </div>
                </div>
            
            </div>
        </div>

    <!-- </div> -->
</template>
<script>
export default {
    data(){
        return{
            countryCodes :  [
                {country : 'USA', countryCode : '+1'},
                {country : 'India', countryCode : '+91'}
            ],
            countrycode : '+1',
            userName: null,
            userEmail: null,
            validPhonenumer : false,
            validEmail : false,
            phoneNumber: null,
            company: '',
            locationName:'',
            Description: ''
            

        }
    },
    methods:{
        checkMobileNumber() {
            var regx = /^[0-9]\d{9}$/ ;
            this.validPhonenumer = regx.test(this.phoneNumber)
            if(this.validPhonenumer){
                document.getElementById('phoneNumber').classList.remove('border-red')
            }else{
                document.getElementById('phoneNumber').classList.add('border-red')
            }
        },
        close() {
        this.$emit('onCloseContact');
        },
        emailValidation() {
      var email = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
      this.validEmail = email.test(this.userEmail)
      if(this.validEmail){
        document.getElementById('email').classList.remove('border-red')
        // this.checkValidation()
      }else{
        document.getElementById('email').classList.add('border-red')
      }
    },
    }
}
</script>

<style  scoped>
.modal-backdrop {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000 !important;
}
.modal-footer{
    background-color: rgba(0, 0, 0, 0.04);
}
.maincard {
  width: 100%;
}
.postmodalcontent{
  border: none !important;
}
.bodymodal11{
    height: 350px;
    overflow: auto;
}
.countrycode{
  width: 40%;
}
.bodymodal11::-webkit-scrollbar {
  display: none;
}
.labelNames{
    color: rgba(0, 0, 0, 0.6);
    font-size: 14px;
}
.card-header {
  border-bottom: none;
}
.card {
  padding: -5px !important;
  margin: 0 auto;
}
.closebtnmouseover{
	 border: 1px solid white;
  width: 28px;
  height: 28px;
  padding-right: 4px;
  margin-top: 3px;
  }
  .closebtnmouseover:hover {
	background-color: rgba(161, 166, 179,0.1);
	border-radius: 60%;
	border: 1px solid rgba(161, 166, 179,.5);
  }
input{
    width: 100%;
    padding: .5em;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    font-size: 14px;
}
.countrycode{
  width: 40%;
}
input:focus{
    outline: none;
}
.postmodalcontent{
  border: none !important;
}
.labels {
  margin-bottom: .15rem;
}
.selectedLabel {
  color: #007AFF !important;
  opacity: 1;
}
</style>